import type { ClimateZone, FarmCreatePayload, FarmUpdatePayload, TaxonPayload } from "@/types";
import type { AxiosError } from "axios";
import Farm from "src/models/farm";
import Taxon from "src/models/taxon";
import Repository from "src/repositories/repository";

const resource = "/farms";

export default {
  async get(): Promise<Farm | null> {
    const { data } = await Repository.get(`${resource}/`);
    if (data[0]) {
      return new Farm(data[0]);
    }
    return null;
  },
  async getSelected(): Promise<Farm | null> {
    try {
      const { data } = await Repository.get(`${resource}/selected/`);
      return new Farm(data);
    } catch (error: unknown) {
      if ((error as AxiosError).response?.status === 404) {
        return null;
      }
      throw error;
    }
  },
  async create(farm: FarmCreatePayload) {
    const { data } = await Repository.post(`${resource}/`, farm);
    return data;
  },
  update(id: number, data: FarmUpdatePayload) {
    return Repository.patch(`${resource}/${id}/`, data);
  },
  async getClimateZone(id: number): Promise<ClimateZone> {
    const { data } = await Repository.get(`${resource}/${id}/climate-zone/`);
    return data;
  },
  async getTaxaRecommendation(id: number, n: number) {
    const { data } = await Repository.get(`${resource}/${id}/recommended-taxa/`, {
      params: { n },
    });

    const { popular, unused_seeds: unusedSeeds } = data;
    return {
      popular: popular.map((taxon: TaxonPayload) => new Taxon(taxon)),
      unusedSeeds: unusedSeeds.map((taxon: TaxonPayload) => new Taxon(taxon)),
    };
  },
  async getStats(id: number) {
    const { data } = await Repository.get(`${resource}/${id}/stats/`);
    return data;
  },
};
